import { UpsellGateway } from './upsell-gateway.interface';

export const initUpsellAPI = (apiSlice: any, gateway: UpsellGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Upsell'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getUpsellById: builder.query({
          query: gateway.getUpsellById,
          providesTags: ['Upsell'],
        }),
        deleteUpsell: builder.mutation({
          query: gateway.deleteUpsell,
          invalidatesTags: ['Upsell', 'Project', 'Configuration'],
        }),
        refuseUpsell: builder.mutation({
          query: gateway.refuseUpsell,
          invalidatesTags: ['Upsell', 'Project', 'Configuration'],
        }),
        getUpsellByProject: builder.query({
          query: gateway.getUpsellByProject,
          providesTags: ['Upsell'],
        }),
        getUpsellByConfiguration: builder.query({
          query: gateway.getUpsellByConfiguration,
          providesTags: ['Upsell'],
        }),
        getUpsellByToken: builder.query({
          query: gateway.getUpsellByToken,
          providesTags: ['Upsell'],
        }),
        sendUpsellSignatureLink: builder.query({
          query: gateway.sendUpsellSignatureLink,
        }),
        patchUpsell: builder.mutation({
          query: gateway.patchUpsell,
          invalidatesTags: ['Upsell', 'Project'],
        }),
        patchSignatureUpsell: builder.mutation({
          query: gateway.patchSignatureUpsell,
          invalidateTags: ['Upsell'],
        }),
        // getTempAmendmentFile: (projectId: string, editableConfig: any) =>
        //   builder.query({
        //     query: gateway.getTempAmendmentFile(projectId, editableConfig),
        //   }),
        getResultOfApplyUpsell: builder.query({
          query: gateway.getResultOfApplyUpsell,
          providesTags: ['Upsell'],
        }),
        getArchiveUpsells: builder.query({
          query: gateway.getArchiveUpsells,
          providesTags: ['Upsell'],
        }),
        getArchiveUpsellsCount: builder.query({
          query: gateway.getArchiveUpsellsCount,
        }),
        postConfigurationsUpsell: builder.mutation({
          query: gateway.postConfigurationsUpsell,
          invalidatesTags: ['Upsell', 'Project', 'Configuration'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface UpsellSliceType {
  useGetUpsellByIdQuery: Function;
  useLazyGetUpsellByIdQuery: Function;
  useDeleteUpsellMutation: Function;
  useRefuseUpsellMutation: Function;
  useGetUpsellByProjectQuery: Function;
  useGetUpsellByConfigurationQuery: Function;
  useGetUpsellByTokenQuery: Function;
  useLazyGetUpsellByTokenQuery: Function;
  useSendUpsellSignatureLinkQuery: Function;
  usePatchUpsellMutation: Function;
  usePatchSignatureUpsellMutation: Function;
  useGetResultOfApplyUpsellQuery: Function;
  useLazyGetResultOfApplyUpsellQuery: Function;
  useGetArchiveUpsellsQuery: Function;
  useLazyGetArchiveUpsellsQuery: Function;
  useGetArchiveUpsellsCountQuery: Function;
  useLazyGetArchiveUpsellsCountQuery: Function;
  usePostConfigurationsUpsellMutation: Function;
}
